// extracted by mini-css-extract-plugin
module.exports = {"SNSButton":"SNSButton_SNSButton__3YJe_","SNSBtnImage":"SNSButton_SNSBtnImage___Oli8"};